<template>
  <tr :key="value.id" @click="$emit('onDetails', value)">
    <td v-for="header in headers" :key="header.text">
      <v-tooltip v-if="header.key === 'Status'" location="bottom">
        <template #activator="{ props }">
          <v-chip :color="value.Status.color" v-bind="props" dark>
            {{ value.Status.name }}
          </v-chip>
        </template>
        <span>{{ value.Status.description }}</span>
      </v-tooltip>

      <v-tooltip v-else-if="header.key === 'Risk'" location="bottom">
        <template #activator="{ props }">
          <v-chip :color="value.Risk.color" v-bind="props" dark>
            <v-icon :icon="value.Risk.icon" start></v-icon>
            {{ value.Risk.name }}
          </v-chip>
        </template>
        <span>{{ value.Risk.description }}</span>
      </v-tooltip>

      <v-tooltip v-else-if="header.key === 'Type'" location="bottom">
        <template #activator="{ props }">
          <div class="d-flex align-center">
            <div class="mr-2 ad-type-img-container">
              <v-img
                width="80"
                v-bind="props"
                :lazy-src="value.AdType.img"
                :src="value.AdType.img"
              />
            </div>
            {{ value.AdType.name }}
          </div>
        </template>
        <span>{{ value.AdType.description }}</span>
      </v-tooltip>

      <v-tooltip
        v-else-if="header.key === 'Website' && value.Website"
        location="bottom"
      >
        <template #activator="{ props }">
          <a
            v-bind="props"
            :href="value.Website.url"
            target="_blank"
            @click.stop
          >
            {{ value.Website.url }}
          </a>
        </template>
        <span>Open</span>
      </v-tooltip>

      <span v-else-if="header.key === 'created_at'">
        {{ formatDates(value.created_at) }}
      </span>

      <span v-else-if="header.key === 'Duration'">
        {{ formatDates(value.Settings.start) }} -
        {{ formatDates(value.Settings.end) }}
      </span>

      <CampaignHourlyClicks
        v-else-if="header.key === 'Clicks'"
        :value="value"
      />
      <CampaignHourlyImpressions
        v-else-if="header.key === 'Impressions'"
        :value="value"
      />
      <CampaignHourlyViews
        v-else-if="header.key === 'Views'"
        :value="value"
      />
      <span v-else>
        {{ value[header.key] }}
      </span>
    </td>
  </tr>
</template>


<script>
import CampaignHourlyClicks from "@/components/molecules/campaign/analytics/CampaignHourlyClicks.vue";
import CampaignHourlyImpressions from "@/components/molecules/campaign/analytics/CampaignHourlyImpressions.vue";
import CampaignHourlyViews from "@/components/molecules/campaign/analytics/CampaignHourlyViews.vue";
import moment from "moment";



export default {
  name: "InventoryItemTableItem",
  components: {
    CampaignHourlyClicks,
    CampaignHourlyImpressions,
    CampaignHourlyViews
  },
  inheritAttrs: false,
  props: {
    headers: {
      type: Array,
      default: () => [],
    },
    value: {
      type: Object,
      default: () => ({}),
    },
  },
  emits: ["onDetails"],
  data() {
    return {
      fullScreenPreview: false,
      labels: ["12am", "3am", "6am", "9am", "12pm", "3pm", "6pm", "9pm"],
      values: [200, 675, 410, 390, 310, 460, 250, 240],
    };
  },
  methods: {
    formatDates(date) {
      return moment(date).format("MMMM Do");
    },
    getStatus(item) {
      return item && item.Status && item.Status.code
        ? {
            text: item.Status.code,
            color: item.Status.color,
          }
        : {
            text: "Unknown",
            color: "grey",
          };
    },
  },
};
</script>


<style lang="scss" scoped>
.ad-type-img-container {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>